<template>
	<div class="back">
		<el-backtop></el-backtop>
		<el-dialog title="查询记录" :width="$store.state.width>$store.state.minwidth?'800px':($store.state.width-12+'px')" :visible.sync="outerVisible">
			<el-table :data="tableData" border style="width: 100%">
				<el-table-column prop="times" label="查询次数" width=""></el-table-column>
				<el-table-column prop="time" label="查询时间" width=""></el-table-column>
				<el-table-column prop="address" label="查询位置"></el-table-column>
			</el-table>
		</el-dialog>
		<el-row>
			<el-col :span="24">
				<div class="header-find">
					<el-row>
						<el-col :md="7" v-if="$store.state.width>$store.state.minwidth">&nbsp;</el-input></el-col>
						<el-col :md="10" class="header-ph">
							<el-col :span="18" class="header-in">
								<el-input :size="$store.state.width>$store.state.minwidth?'medium':'mini'" v-model="find" placeholder="请输入溯源码"></el-input>
							</el-col>
							<el-col :span="6" style="text-align: center;">
								<el-button type="primary" :size="$store.state.width>$store.state.minwidth?'medium':'mini'" @click="load()">查 询</el-button>
							</el-col>
						</el-col>
						<el-col :md="7" v-if="$store.state.width>$store.state.minwidth">&nbsp;</el-input></el-col>
					</el-row>
				</div>
			</el-col>
		</el-row>
		<el-row v-if="$store.getters.detailsT!=null" class="det-main">
			<el-col :span="24">
				<el-row class="backwihte">
					<el-col :span="24">
						<el-divider content-position="left">基本信息</el-divider>
					</el-col>
				</el-row>
				<el-row class="det-header">
					<el-col :md="10" style="text-align: center;" class="backwihte">
						<el-image class="header-img" :src="$store.getters.detailsT.avatar" :preview-src-list="$store.getters.detailsT.images" title="点击查看大图"></el-image>
					</el-col>
					<el-col :md="14" v-if="$store.state.width<$store.state.minwidth" class="phone-times">
						<el-row>
							<el-col :span="24" class="pts-title-div">
								<div class="pts-title">
									查询结果
								</div>
							</el-col>
							<el-col :span="24" class="backwihte pts-content">
								<i class="el-icon-warning-outline" style="color: #f79544; font-size: 25px;"></i>您查询的编码为 <span style="color: #f79544;">{{$route.query.code}}</span> ，尊敬的客户您好，您所查询的商品是由成都市易农科技有限公司养殖、销售的高原生态牦牛肉，产自色达县牦牛核心产区，请放心食用！
							</el-col>
							<el-col :span="24" class="backwihte pts-times">
								<span style="color: #c5b1b1;">查询次数：</span>4 <el-button @click="outerVisible=true" size="mini" round style="border: none; float: right; background-color: #51b202; color: white;">查询记录</el-button>
							</el-col>
							<el-col :span="24" class="backwihte pts-time">
								<span style="color: #c5b1b1;">首查时间：</span>2019-10-08 10:15:30
							</el-col>
						</el-row>
					</el-col>
					<el-col :md="14" class="header-xx backwihte">
						<el-row class="header-xx-main">
							<el-col :span="24">
								<el-row class="border-b">
									<el-col :span="8" class="header-xx-title">
										<b>名称</b>
									</el-col>
									<el-col :span="16" class="header-xx-content">
										<span>{{$store.getters.detailsT.alias}}</span>
									</el-col>
								</el-row>
								<el-row class="border-b">
									<el-col :span="8" class="header-xx-title">
										<b>编号</b>
									</el-col>
									<el-col :span="16" class="header-xx-content">
										<span>{{$store.getters.detailsT.soleno}}</span>
									</el-col>
								</el-row>
								<el-row class="border-b">
									<el-col :span="8" class="header-xx-title">
										<b>产品性别</b>
									</el-col>
									<el-col :span="16" class="header-xx-content">
										<span>{{$store.getters.detailsT.csexName}}</span>
									</el-col>
								</el-row>
								<el-row class="border-b">
									<el-col :span="8" class="header-xx-title">
										<b>价值</b>
									</el-col>
									<el-col :span="16" class="header-xx-content">
										<span>{{$store.getters.detailsT.price}}元/斤</span>
									</el-col>
								</el-row>
								<el-row class="border-b">
									<el-col :span="8" class="header-xx-title">
										<b>喂养时间</b>
									</el-col>
									<el-col :span="16" class="header-xx-content">
										<span>{{Totime($store.getters.detailsT.createtime)}}</span>
									</el-col>
								</el-row>
								<el-row class="border-b">
									<el-col :span="8" class="header-xx-title">
										<b>出栏时间</b>
									</el-col>
									<el-col :span="16" class="header-xx-content">
										<span>{{Totime($store.getters.detailsT.updatetime)}}</span>
									</el-col>
								</el-row>
								<el-row class="border-b">
									<el-col :span="8" class="header-xx-title">
										<b>负责人</b>
									</el-col>
									<el-col :span="16" class="header-xx-content">
										<span>{{$store.getters.detailsT.userData.username}}</span>
									</el-col>
								</el-row>
								<el-row>
									<el-col :span="24" class="border-b header-xx-title">
										<b>简介</b>
									</el-col>
									<el-col :span="24" class="header-xx-content">
										<span>{{$store.getters.detailsT.description}}</span>
									</el-col>
								</el-row>
							</el-col>
						</el-row>
					</el-col>
				</el-row>
				<el-row class="backwihte">
					<el-col :span="24">
						<el-divider content-position="left">品种信息</el-divider>
					</el-col>
				</el-row>
				<el-row class="backwihte">
					<el-col :span="24" class="pz-main">
						<el-row>
							<el-col :md="16" v-if="$store.state.width<$store.state.minwidth">
								<el-carousel :interval="3000" type="card" :height="$store.state.width<$store.state.minwidth?'20vh':'30vh'">
									<el-carousel-item v-for="item in $store.getters.detailsT.speciesDetailsData.images" :key="item">
										<img class="pz-xx-img" :src="item" alt="">
									</el-carousel-item>
								</el-carousel>
							</el-col>
							<el-col :md="8" class="pz-xx-main">
								<el-row class="border-b">
									<el-col :span="8" class="pz-xx-title">
										<b>品种名</b>
									</el-col>
									<el-col :span="16" class="px-xx-content">
										<span>{{$store.getters.detailsT.speciesDetailsData.name}}</span>
									</el-col>
								</el-row>
								<el-row class="border-b">
									<el-col :span="8" class="pz-xx-title">
										<b>类型</b>
									</el-col>
									<el-col :span="16" class="px-xx-content">
										<span>{{$store.getters.detailsT.speciesDetailsData.typeName}}</span>
									</el-col>
								</el-row>
								<el-row class="border-b">
									<el-col :span="8" class="pz-xx-title">
										<b>颜色</b>
									</el-col>
									<el-col :span="16" class="px-xx-content">
										<span>{{$store.getters.detailsT.speciesDetailsData.colour}}</span>
									</el-col>
								</el-row>
								<el-row class="border-b">
									<el-col :span="8" class="pz-xx-title">
										<b>品种</b>
									</el-col>
									<el-col :span="16" class="px-xx-content">
										<span>{{$store.getters.detailsT.speciesDetailsData.variety}}</span>
									</el-col>
								</el-row>
								<el-row class="border-b">
									<el-col :span="8" class="pz-xx-title">
										<b>最大重量</b>
									</el-col>
									<el-col :span="16" class="px-xx-content">
										<span>{{$store.getters.detailsT.speciesDetailsData.weightmax}}</span>
									</el-col>
								</el-row>
								<el-row class="border-b">
									<el-col :span="8" class="pz-xx-title">
										<b>营养成分</b>
									</el-col>
									<el-col :span="16" class="px-xx-content">
										<span>{{$store.getters.detailsT.speciesDetailsData.nutrition}}</span>
									</el-col>
								</el-row>
								<el-row class="border-b">
									<el-col :span="8" class="pz-xx-title">
										<b>生活类型</b>
									</el-col>
									<el-col :span="16" class="px-xx-content">
										<span>{{$store.getters.detailsT.speciesDetailsData.subsistName}}</span>
									</el-col>
								</el-row>
								<el-row class="border-b">
									<el-col :span="8" class="pz-xx-title">
										<b>适宜生存温度</b>
									</el-col>
									<el-col :span="16" class="px-xx-content">
										<span>{{$store.getters.detailsT.speciesDetailsData.temperature}}</span>
									</el-col>
								</el-row>
								<el-row class="border-b">
									<el-col :span="24" class="pz-xx-title">
										<b>口感</b>
									</el-col>
								</el-row>
								<el-row class="border-b">
									<el-col :span="24" class="px-xx-content">
										<span>{{$store.getters.detailsT.speciesDetailsData.taste}}</span>
									</el-col>
								</el-row>
								<el-row class="border-b">
									<el-col :span="24" class="pz-xx-title">
										<b>适宜生存方式</b>
									</el-col>
								</el-row>
								<el-row class="border-b">
									<el-col :span="24" class="px-xx-content">
										<span>{{$store.getters.detailsT.speciesDetailsData.survival}}</span>
									</el-col>
								</el-row>
								<el-row class="border-b">
									<el-col :span="24" class="pz-xx-title">
										<b>外观</b>
									</el-col>
								</el-row>
								<el-row class="border-b">
									<el-col :span="24" class="px-xx-content">
										<span>{{$store.getters.detailsT.speciesDetailsData.facade}}</span>
									</el-col>
								</el-row>
								<el-row class="border-b">
									<el-col :span="24" class="pz-xx-title">
										<b>描述</b>
									</el-col>
								</el-row>
								<el-row>
									<el-col :span="24" class="px-xx-content">
										<span>{{$store.getters.detailsT.speciesDetailsData.description}}</span>
									</el-col>
								</el-row>
							</el-col>
							<el-col :md="16" v-if="$store.state.width>$store.state.minwidth" class="pz-xx-wztu">
								<el-carousel :interval="3000" type="card" :height="$store.state.width<$store.state.minwidth?'20vh':'30vh'">
									<el-carousel-item v-for="item in $store.getters.detailsT.speciesDetailsData.images" :key="item">
										<img class="pz-xx-img" :src="item" alt="">
									</el-carousel-item>
								</el-carousel>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="24">
								<el-divider content-position="left"></el-divider>
							</el-col>
						</el-row>
						<el-row>
							<el-col :md="12" class="pz-shzh">
								<b>生长图片</b>
								<el-carousel :interval="3000" height="300px" direction="vertical" :autoplay="true">
									<el-carousel-item v-for="(url,index) in $store.getters.detailsT.speciesDetailsData.growimage" :key="index">
										<img class="pz-shzh-img" :src="url" alt="">
									</el-carousel-item>
								</el-carousel>
							</el-col>
							<el-col :md="12" class="pz-rzh">
								<b>认证图片</b>
								<div class="pz-xx-shzh">
									<el-image v-for="(url,index) in $store.getters.detailsT.speciesDetailsData.authimage" :key="index" :src="url" :preview-src-list="$store.getters.detailsT.speciesDetailsData.authimage" title="点击查看大图"></el-image>
								</div>
							</el-col>
						</el-row>
					</el-col>
				</el-row>
				<el-row class="backwihte">
					<el-col :span="24">
						<el-divider content-position="left">消耗品使用记录</el-divider>
					</el-col>
				</el-row>
				<el-row class="backwihte">
					<el-col :span="24">
						<el-timeline>
							<el-timeline-item v-for="item in $store.getters.detailsT.recordData" :timestamp="Totime(item.createtime).split(' ')[0]" placement="top" :key="item.id">
								<el-row v-if="$store.state.width<$store.state.minwidth">
									<el-col :span="24">
										<el-tabs type="border-card" style="box-shadow: none;">
											<el-tab-pane label="操作详情">
												<el-row class="xh-xq-main">
													<el-col :span="24">
														<el-row class="border-b">
															<el-col :span="8" class="xh-xq-header">
																<b>名称</b>
															</el-col>
															<el-col :span="16" class="header-xx-content">
																<span>{{item.name}}</span>
															</el-col>
														</el-row>
														<el-row class="border-b">
															<el-col :span="8" class="xh-xq-header">
																<b>消耗品名</b>
															</el-col>
															<el-col :span="16" class="header-xx-content">
																<span>{{item.eat.alias}}</span>
															</el-col>
														</el-row>
														<el-row class="border-b">
															<el-col :span="8" class="xh-xq-header">
																<b>消耗品类型</b>
															</el-col>
															<el-col :span="16" class="header-xx-content">
																<span>{{item.eat.eatName}}</span>
															</el-col>
														</el-row>
														<el-row class="border-b">
															<el-col :span="8" class="xh-xq-header">
																<b>使用数量</b>
															</el-col>
															<el-col :span="16" class="header-xx-content">
																<span>{{item.num}}</span>
															</el-col>
														</el-row>
														<el-row>
															<el-col :span="24" class="xh-xq-header border-b">
																<b>现场图片</b>
															</el-col>
															<el-col :span="24" class="header-xx-content border-b">
																<el-image class="xh-xq-img" v-for="(img,index) in item.images" :src="img" :preview-src-list="item.images" title="点击查看大图" :key="index"></el-image>
															</el-col>
														</el-row>
														<el-row>
															<el-col :span="24" class="xh-xq-header border-b">
																<b>描述</b>
															</el-col>
															<el-col :span="24" class="header-xx-content">
																<span>{{item.description}}</span>
															</el-col>
														</el-row>
													</el-col>
												</el-row>
												<el-row>
													<el-col :span="24">
														<span>{{item.operatorname+" 操作于 "+Totime(item.createtime)}}</span>
													</el-col>
												</el-row>
											</el-tab-pane>
											<el-tab-pane label="消耗品详情">
												<el-row class="xh-xq-main">
													<el-col :span="24">
														<el-row class="border-b">
															<el-col :span="8" class="xh-xq-header">
																<b>消耗品名</b>
															</el-col>
															<el-col :span="16" class="header-xx-content">
																<span>{{item.eat.alias}}</span>
															</el-col>
														</el-row>
														<el-row class="border-b">
															<el-col :span="8" class="xh-xq-header">
																<b>规格</b>
															</el-col>
															<el-col :span="16" class="header-xx-content">
																<span>{{item.eat.norms}}</span>
															</el-col>
														</el-row>
														<el-row class="border-b">
															<el-col :span="8" class="xh-xq-header">
																<b>特征</b>
															</el-col>
															<el-col :span="16" class="header-xx-content">
																<span>{{item.eat.trait}}</span>
															</el-col>
														</el-row>
														<el-row class="border-b">
															<el-col :span="8" class="xh-xq-header">
																<b>生产厂家</b>
															</el-col>
															<el-col :span="16" class="header-xx-content">
																<span>{{item.eat.vender}}</span>
															</el-col>
														</el-row>
														<el-row v-show="item.eat.eat=='drug'" class="border-b">
															<el-col :span="8" class="xh-xq-header">
																<b>是否为疫苗</b>
															</el-col>
															<el-col :span="16" class="header-xx-content">
																<span>{{item.eat.vaccine}}</span>
															</el-col>
														</el-row>
														<el-row v-show="item.eat.eat=='drug'" class="border-b">
															<el-col :span="8" class="xh-xq-header">
																<b>使用方法</b>
															</el-col>
															<el-col :span="16" class="header-xx-content">
																<span>{{item.eat.inoculamethod}}</span>
															</el-col>
														</el-row>
														<el-row>
															<el-col :span="24" class="xh-xq-header border-b">
																<b>物品图片</b>
															</el-col>
															<el-col :span="24" class="header-xx-content border-b">
																<el-image class="xh-xq-img" v-for="(img,index) in item.eat.images" :src="img" :preview-src-list="item.eat.images" title="点击查看大图" :key="index"></el-image>
															</el-col>
														</el-row>
														<el-row>
															<el-col :span="24" class="xh-xq-header border-b">
																<b>简介</b>
															</el-col>
															<el-col :span="24" class="header-xx-content">
																<span>{{item.eat.description}}</span>
															</el-col>
														</el-row>
													</el-col>
												</el-row>
												<el-row>
													<el-col :span="24">
														<span>{{item.operatorname+" 操作于 "+Totime(item.createtime)}}</span>
													</el-col>
												</el-row>
											</el-tab-pane>
										</el-tabs>
									</el-col>
								</el-row>
								<el-card v-else class="xhp-card" shadow="hover" :body-style="{ padding: $store.state.width<$store.state.minwidth?'2px':'20px' }">
									<el-row>
										<el-col :md="12">
											<el-row>
												<el-col :span="24">
													<span>操作详情</span>
												</el-col>
											</el-row>
											<el-row class="xh-xq-main">
												<el-col :span="24">
													<el-row class="border-b">
														<el-col :span="8" class="xh-xq-header">
															<span>名称</span>
														</el-col>
														<el-col :span="16" class="header-xx-content">
															<span>{{item.name}}</span>
														</el-col>
													</el-row>
													<el-row class="border-b">
														<el-col :span="8" class="xh-xq-header">
															<span>消耗品名</span>
														</el-col>
														<el-col :span="16" class="header-xx-content">
															<span>{{item.eat.alias}}</span>
														</el-col>
													</el-row>
													<el-row class="border-b">
														<el-col :span="8" class="xh-xq-header">
															<span>消耗品类型</span>
														</el-col>
														<el-col :span="16" class="header-xx-content">
															<span>{{item.eat.eatName}}</span>
														</el-col>
													</el-row>
													<el-row class="border-b">
														<el-col :span="8" class="xh-xq-header">
															<span>使用数量</span>
														</el-col>
														<el-col :span="16" class="header-xx-content">
															<span>{{item.num}}</span>
														</el-col>
													</el-row>
													<el-row>
														<el-col :span="24" class="xh-xq-header border-b">
															<span>现场图片</span>
														</el-col>
														<el-col :span="24" class="header-xx-content border-b">
															<el-image class="xh-xq-img" v-for="(img,index) in item.images" :src="img" :preview-src-list="item.images" title="点击查看大图" :key="index"></el-image>
														</el-col>
													</el-row>
													<el-row>
														<el-col :span="24" class="xh-xq-header border-b">
															<span>描述</span>
														</el-col>
														<el-col :span="24" class="header-xx-content">
															<span>{{item.description}}</span>
														</el-col>
													</el-row>
												</el-col>
											</el-row>
										</el-col>
										<el-col :md="12">
											<el-row>
												<el-col :span="24">
													<span>消耗品详情</span>
												</el-col>
											</el-row>
											<el-row class="xh-xq-main">
												<el-col :span="24">
													<el-row class="border-b">
														<el-col :span="8" class="xh-xq-header">
															<span>消耗品名</span>
														</el-col>
														<el-col :span="16" class="header-xx-content">
															<span>{{item.eat.alias}}</span>
														</el-col>
													</el-row>
													<el-row class="border-b">
														<el-col :span="8" class="xh-xq-header">
															<span>规格</span>
														</el-col>
														<el-col :span="16" class="header-xx-content">
															<span>{{item.eat.norms}}</span>
														</el-col>
													</el-row>
													<el-row class="border-b">
														<el-col :span="8" class="xh-xq-header">
															<span>特征</span>
														</el-col>
														<el-col :span="16" class="header-xx-content">
															<span>{{item.eat.trait}}</span>
														</el-col>
													</el-row>
													<el-row class="border-b">
														<el-col :span="8" class="xh-xq-header">
															<span>生产厂家</span>
														</el-col>
														<el-col :span="16" class="header-xx-content">
															<span>{{item.eat.vender}}</span>
														</el-col>
													</el-row>
													<el-row v-show="item.eat.eat=='drug'" class="border-b">
														<el-col :span="8" class="xh-xq-header">
															<span>是否为疫苗</span>
														</el-col>
														<el-col :span="16" class="header-xx-content">
															<span>{{item.eat.vaccine}}</span>
														</el-col>
													</el-row>
													<el-row v-show="item.eat.eat=='drug'" class="border-b">
														<el-col :span="8" class="xh-xq-header">
															<span>使用方法</span>
														</el-col>
														<el-col :span="16" class="header-xx-content">
															<span>{{item.eat.inoculamethod}}</span>
														</el-col>
													</el-row>
													<el-row>
														<el-col :span="24" class="xh-xq-header border-b">
															<span>物品图片</span>
														</el-col>
														<el-col :span="24" class="header-xx-content border-b">
															<el-image class="xh-xq-img" v-for="(img,index) in item.eat.images" :src="img" :preview-src-list="item.eat.images" title="点击查看大图" :key="index"></el-image>
														</el-col>
													</el-row>
													<el-row>
														<el-col :span="24" class="xh-xq-header border-b">
															<span>简介</span>
														</el-col>
														<el-col :span="24" class="header-xx-content">
															<span>{{item.eat.description}}</span>
														</el-col>
													</el-row>
												</el-col>
											</el-row>
										</el-col>
									</el-row>
									<el-row>
										<el-col :span="24">
											<span>{{item.operatorname+" 操作于 "+Totime(item.createtime)}}</span>
										</el-col>
									</el-row>
								</el-card>
							</el-timeline-item>
						</el-timeline>
					</el-col>
				</el-row>
				<el-row class="backwihte">
					<el-col :span="24">
						<el-divider content-position="left">其他信息</el-divider>
					</el-col>
				</el-row>
				<el-row class="backwihte">
					<el-col :span="24" class="qt-main">
						<el-tabs type="border-card" style="box-shadow: none;">
							<el-tab-pane label="基地信息">
								<el-row>
									<el-col :md="14" class="qt-xx-main">
										<el-row class="border-b">
											<el-col :span="8" class="pz-xx-title">
												<b>基地名</b>
											</el-col>
											<el-col :span="16" class="px-xx-content">
												<span>{{$store.getters.detailsT.qaedaData.name}}</span>
											</el-col>
										</el-row>
										<el-row class="border-b">
											<el-col :span="8" class="pz-xx-title">
												<b>地址</b>
											</el-col>
											<el-col :span="16" class="px-xx-content">
												<span>{{$store.getters.detailsT.qaedaData.address}}</span>
											</el-col>
										</el-row>
										<el-row>
											<el-col :span="24" class="border-b pz-xx-title">
												<b>简介</b>
											</el-col>
											<el-col :span="24" class="px-xx-content">
												<span>{{$store.getters.detailsT.qaedaData.content}}</span>
											</el-col>
										</el-row>
									</el-col>
									<el-col :md="10">
										
									</el-col>
								</el-row>
							</el-tab-pane>
							<el-tab-pane label="负责人信息">
								<el-row>
									<el-col :md="14" class="qt-xx-main">
										<el-row class="border-b">
											<el-col :span="8" class="pz-xx-title">
												<b>姓名</b>
											</el-col>
											<el-col :span="16" class="px-xx-content">
												<span>{{$store.getters.detailsT.userData.username}}</span>
											</el-col>
										</el-row>
										<el-row class="border-b">
											<el-col :span="8" class="pz-xx-title">
												<b>性别</b>
											</el-col>
											<el-col :span="16" class="px-xx-content">
												<span>{{$store.getters.detailsT.userData.sexName}}</span>
											</el-col>
										</el-row>
										<el-row>
											<el-col :span="24" class="border-b pz-xx-title">
												<b>简介</b>
											</el-col>
											<el-col :span="24" class="px-xx-content">
												<span>{{$store.getters.detailsT.userData.signature}}</span>
											</el-col>
										</el-row>
									</el-col>
									<el-col :md="10">
										<el-image class="qt-img" :src="$store.getters.detailsT.userData.avatar"></el-image>
									</el-col>
								</el-row>
							</el-tab-pane>
						</el-tabs>
					</el-col>
				</el-row>
				<el-row class="footer-dx backwihte">
					<el-col :span="24">
						<el-divider content-position="center">我是有底线的</el-divider>
					</el-col>
				</el-row>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				find: this.$route.query.code,
				outerVisible: false,
				tableData:[
					{
						times: "第4次",
						time: "2019-10-08 14:00:30",
						address: "成都市"
					},
					{
						times: "第3次",
						time: "2019-10-08 11:00:30",
						address: "上海市"
					},
					{
						times: "第2次",
						time: "2019-10-08 10:00:30",
						address: "天津市"
					},
					{
						times: "第1次",
						time: "2019-10-08 09:00:30",
						address: "北京市"
					}
				]
			}
		},
		watch: {
			$route: {
				handler: function(val, oldVal){
					
				}
			}
		},
		mounted: function () {
			this.load();
		},
		methods: {
			load()
			{
				if(this.find==null)
				{
					return;
				}
				let value={
					guid: this.find
				}
				this.gettrace(value);
				if(window.location.host=="yny.farmereasy.com")
				{
					window.location="https://www.yny.cloud/details?code="+this.$route.query.code;
				}
			}
		}
	}
</script>

<style scoped>
	.header-find{
		position: fixed;
		top: 0px;
		width: 100%;
		z-index: 99;
		padding: 15px 0;
		background-color: white;
		box-shadow: 0 0 5px #888;
	}
	.header-in{
		padding: 0 20px;
	}
	.back{
		background-image: url(../../assets/traceability/back.jpg);
		background-attachment: fixed;
		background-repeat: no-repeat;
		background-size: cover;
	}
	.det-main{
		margin: 0px 15%;
		margin-top: 66px;
		/* border: 1px solid #dcdfe6; */
		border-bottom: none;
		/* background-color: white; */
	}
	.det-header{
		height: 390px;
		/* margin: 0 40px; */
	}
	.header-img{
		width: auto;
		height: 390px;
	}
	.header-xx{
		padding-left: 20px;
		height: 390px;
	}
	.header-xx-main{
		line-height: 30px;
		border: 1px solid #dcdfe6;
		padding: 5px;
		border-radius: 5px;
		height: 390px;
		overflow-y: auto;
	}
	.border-b{
		border-bottom: 1px solid #dcdfe6;
	}
	.header-xx-title{
		font-weight: 600;
	}
	.header-xx-content{
		font-size: 15px;
		color: #2f2f2f;
	}
	.xhp-card{
		margin-right: 40px;
	}
	.xh-xq-main{
		border: 1px solid #dcdfe6;
		border-radius: 5px;
		margin: 5px 10px 15px 0px;
		padding: 5px;
		line-height: 30px;
		font-size: 16px;
		height: 390px;
		overflow-y: auto;
	}
	.xh-xq-header{
		font-weight: 600;
	}
	.xh-xq-img{
		height: 80px;
		width: 80px;
		border: 1px solid #dcdfe6;
		border-radius: 5px;
		margin-right: 10px;
		margin-top: 10px;
	}
	.pz-xx-img{
		width: 100%;
		height: 30vh;
	}
	.pz-main{
		padding: 0 40px;
	}
	.pz-xx-main{
		border: 1px solid #dcdfe6;
		border-radius: 5px;
		padding: 5px;
		line-height: 25px;
		font-size: 14px;
		height: 500px;
		overflow-y: auto;
	}
	.qt-xx-main{
		border: 1px solid #dcdfe6;
		border-radius: 5px;
		padding: 5px;
		line-height: 25px;
		font-size: 14px;
		height: 300px;
		overflow-y: auto;
	}
	.pz-xx-title{
		font-weight: 600;
	}
	.pz-xx-content{
		font-weight: 300;
		font-size: 12px;
	}
	.pz-xx-wztu{
		padding-left: 20px;
		margin-top: 80px;
	}
	.pz-xx-shzh{
		height: 300px;
		overflow-y: auto;
		border: 1px solid #dcdfe6;
	}
	.pz-shzh{
		margin-top: 10px;
		padding-right: 10px;
	}
	.pz-shzh-img{
		width: 100%;
		height: 100%;
	}
	.pz-rzh{
		margin-top: 10px;
		padding-left: 10px;
	}
	.footer-dx{
		padding: 10px 0;
		background-color: #ffffff;
	}
	.qt-main{
		padding: 0px 40px;
	}
	.qt-img{
		padding-left: 20px;
		height: 300px;
	}
	.phone-times{
		background-color: rgba(0,0,0,0);
	}
	.pts-title-div{
		position: relative;
		height: 55px;
	}
	.pts-title{
		margin: auto;
		border-radius: 15px;
		background: #fff;
		border-radius: 20px;
		width: 40%;
		text-align: center;
		height: 40px;
		line-height: 40px;
		font-size: 20px;
		position: absolute;
		bottom: -5px;
		z-index: 0;
		left: 50%;
		margin-left: -20%;
		color: #f79544;
	}
	.pts-content{
		z-index: 1;
		padding: 0px 8px;
		padding-top: 15px;
		padding-bottom: 10px;
		font-size: 18px;
	}
	.pts-times{
		border-top: 1px dashed #dddddd;
		padding: 0px 8px;
		padding-top: 10px;
	}
	.pts-time{
		padding: 0px 8px;
		padding-top: 10px;
		padding-bottom: 8px;
		margin-bottom: 15px;
	}
	.backwihte{
		background-color: white;
	}
	@media screen and (min-width: 0px) and (max-width: 700px){
		.header-find{
			padding: 10px 0;
		}
		.header-in{
			padding: 0;
			padding-right: 10px;
			padding-left: 10px;
		}
		.header-ph{
			padding: 0 5px;
		}
		.det-main{
			margin: 5px;
			margin-top: 48px;
		}
		.det-header{
			margin: 0;
			height: auto;
		}
		.header-img{
			height: 280px;
		}
		.header-xx{
			padding: 0px;
		}
		.el-timeline{
			padding: 0;
		}
		.xhp-card{
			margin-right: 0px;
		}
		.pz-xx-img{
			height: 20vh;
		}
		.xh-xq-main{
			margin-right: 0px;
		}
		.pz-main{
			padding: 0;
		}
		.pz-shzh{
			margin-top: 0px;
			padding-right: 0px;
		}
		.pz-rzh{
			padding-left: 0px;
		}
		.qt-img{
			padding-left: 0px;
			margin-top: 5px;
		}
		.qt-main{
			padding: 0px;
		}
		.pz-xx-main{
			height: auto;
		}
	}
</style>

<style>
	.el-message-box {
		width: 350px !important;
	}
</style>